module.exports = __webpack_public_path__ + "static/media/OE-Leonie-schema_adaptif.6d36ff8c.jpg";